import PatientBreadcrumbs from './PatientBreadcrumbs'

export default PatientBreadcrumbs
